
	import  { Component } from 'react';
	import SolicitudSesion from './components/SolicitudSesion';

	import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';

	class App extends Component
	{
	
		render()
		{
			const URLParams = new URLSearchParams(window.location.search);
			
			let cc = URLParams.get("cc");
			
			return(
				<BrowserRouter>
					<Routes>
					  <Route path="/">
			        { cc && 
			          <Route path="/" element=<Navigate to={"/solicitudCitas?cc=" + cc} replace={true}/> />
			        }
			        { !cc && 
			          <Route path="/" element=<Navigate to="/solicitudCitas"/> />
			        }
					  </Route>
						
						<Route path="/solicitudCitas" element={<SolicitudSesion/>} />
					</Routes>
				</BrowserRouter>
			);
		}
	}

	export default App;